// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1ClusterRole = {
  ClusterRoleBrain: 'brain',
  ClusterRoleOrchestra: 'orchestra',
  ClusterRoleIngress: 'ingress',
  ClusterRoleApplication: 'application',
  ClusterRoleObjectStorage: 'object-storage',
  ClusterRoleCspBrain: 'csp-brain',
  ClusterRoleOmniCd: 'omni-cd',
  ClusterRoleOmniCi: 'omni-ci',
  ClusterRoleOmniSurface: 'omni-surface',
  ClusterRoleOmniImsManagement: 'omni-ims-management',
  ClusterRoleOmniImsProvisioning: 'omni-ims-provisioning',
} as const;
export type V1ClusterRole = (typeof V1ClusterRole)[keyof typeof V1ClusterRole];

export function instanceOfV1ClusterRole(value: any): boolean {
  for (const key in V1ClusterRole) {
    if (Object.prototype.hasOwnProperty.call(V1ClusterRole, key)) {
      if (V1ClusterRole[key as keyof typeof V1ClusterRole] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1ClusterRoleFromJSON(json: any): V1ClusterRole {
  return V1ClusterRoleFromJSONTyped(json, false);
}

export function V1ClusterRoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterRole {
  return json as V1ClusterRole;
}

export function V1ClusterRoleToJSON(value?: V1ClusterRole | null): any {
  return value as any;
}

export function V1ClusterRoleToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1ClusterRole {
  return value as V1ClusterRole;
}
